export default {
    showPopup: false,
    bookings: [],
};



// WEBPACK FOOTER //
// ./src/core/store/bookings/state.ts